var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgStar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1912 7.13241L11.3103 1.10315C10.9392 -0.080281 9.2247 -0.080281 8.86644 1.10315L6.97278 7.13241H1.27899C0.0378699 7.13241 -0.473931 8.68955 0.536876 9.38715L5.19427 12.626L3.36458 18.3688C2.99352 19.5273 4.37539 20.4616 5.3606 19.7266L10.082 16.2386L14.8033 19.739C15.7886 20.474 17.1704 19.5397 16.7994 18.3812L14.9697 12.6385L19.6271 9.39961C20.6379 8.68955 20.1261 7.14486 18.8849 7.14486H13.1912V7.13241Z",
    fill: "#6D675F"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/star.9974a14d.svg";
export { ForwardRef as ReactComponent };